"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var react_1 = __importStar(require("react"));
var react_nano_spinner_1 = __importDefault(require("react-nano-spinner"));
var useRerender_1 = require("../useRerender");
function Spinner(props) {
    var children = props.children, fullScreen = props.fullScreen, timeoutMs = props.timeoutMs;
    var contents = children || react_1.default.createElement(react_nano_spinner_1.default, null);
    useRerender_1.useRerenderEvery(1000);
    var mountedAt = react_1.useState(Date.now())[0];
    var timeout = timeoutMs !== null && timeoutMs !== void 0 ? timeoutMs : 60000;
    if (mountedAt + timeout < Date.now())
        throw new Error("Spinner is taking too long");
    if (fullScreen) {
        return (react_1.default.createElement("div", { style: {
                alignItems: "center",
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                left: 0,
                position: "absolute",
                right: 0,
                top: 0,
                zIndex: 2,
            } },
            react_1.default.createElement("div", null, contents)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, "contents");
}
exports.Spinner = Spinner;
//# sourceMappingURL=index.js.map